import { Link } from "react-router-dom";

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  categoryName: string;
  categorySlug: string;
  tags: string[];
  views: number;
  likes: number;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  image,
  date,
  categoryName,
  categorySlug,
  tags,
  views,
  likes,
}: ArticleCardProps) {
  const formatCount = (n: number) => {
    if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
    if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
    return `${n}`;
  };

  return (
    <article className="group bg-background-50 rounded-lg border border-background-200 hover:border-primary-200 transition-all duration-300 overflow-hidden">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative overflow-hidden aspect-video">
          <div className="w-full h-full">
            <img
              src={image}
              alt={title}
              title={`B站暴躁少女CSGO视频 ${title}`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${categorySlug}`}
              className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500/90 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {categoryName}
            </Link>
          </div>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
            {excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-500">
            <div className="flex items-center gap-3 flex-wrap">
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                {date}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {formatCount(views)}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-thumb-up-line"></i>
                {formatCount(likes)}
              </span>
            </div>
          </div>
          {tags.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-3">
              {tags.slice(0, 3).map((tag) => (
                <span
                  key={tag}
                  className="px-2 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap"
                >
                  #{tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </Link>
    </article>
  );
}